import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Toast from 'src/components/Toast/Toast'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './redux/store'
import Bootsrap from './layout/Bootstrap'
import { ssoResponse, setLoading, setSelectCountryDialog } from './redux/slices/bootStrapSlice'

import { EventType, PublicClientApplication } from '@azure/msal-browser'
import config from './azureConfig'

const pca = new PublicClientApplication(config)

pca.addEventCallback((e) => {
  if (e.eventType === EventType.LOGIN_SUCCESS) {
    store.dispatch(ssoResponse({ body: e.payload, pca }))
  }
})

ReactDOM.render(
  <Provider store={store}>
    <Bootsrap>
      <App msalInstance={pca} />
      <Toast />
    </Bootsrap>
  </Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
